<nav class="navbar" [class.scrolled]="isScrolled">
  <div class="navbar-container">
    <div [routerLink]="appRoutes.home" class="nav-logo-container">
      <img src="/public/images/asoul_logo.svg" alt="Momah Company Logo" loading="lazy">
    </div>

    <ul class="nav-links" id="main-navigation">
      <li><a [routerLink]="appRoutes.home" routerLinkActive="active"
             [routerLinkActiveOptions]="{exact: true}">{{ 'navbar.home' | translate }}</a></li>
      <!-- <li><a routerLink="/main/extractor" routerLinkActive="active"
             [routerLinkActiveOptions]="{exact: true}">{{ 'navbar.extractor' | translate }}</a></li> -->
      <li><a [routerLink]="appRoutes.assetsStatus" routerLinkActive="active">{{ 'navbar.assetsStatus' | translate }}</a></li>
      <li><a [routerLink]="appRoutes.assetsPrice"  routerLinkActive="active">{{ 'navbar.assetPrices' | translate }}</a></li>
      <li><a [routerLink]="appRoutes.analysisBase" routerLinkActive="active">{{ 'navbar.analysis' | translate }}</a></li>

      <!--      <li><a routerLink="/main/project-management" routerLinkActive="active">{{ 'navbar.projectManagement' | translate }}</a></li>-->
            <li><a [routerLink]="appRoutes.virtualAdvisor" routerLinkActive="active">{{ 'navbar.virtualAdvisor' | translate }}</a></li>
      <li><a [routerLink]="appRoutes.repository" routerLinkActive="active">{{ 'navbar.repository' | translate }}</a></li>
    </ul>

    <div class="nav-icons">
      <div class="lang-key" (click)="toggleLanguage(language === 'en' ? 'ar' : 'en')">
        {{ language === 'en' ? 'AR' : 'EN' }}
      </div>

      <span class="user-icon" (click)="logout()">
        <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="15.3438" cy="15" r="14.25" stroke="#FFFFFF" stroke-width="1.5"/>
          <path
            d="M19.3275 9.94754V12.3969C19.3275 14.3439 17.7287 15.9213 15.7553 15.9213H14.9326C12.9592 15.9213 11.3604 14.3439 11.3604 12.3969V9.94754C11.3604 9.8158 11.3671 9.6863 11.3807 9.56127C11.5776 7.79515 13.0939 6.422 14.9338 6.422H15.7564C17.5963 6.422 19.1114 7.79515 19.3094 9.56127C19.323 9.6863 19.3298 9.8158 19.3298 9.94754H19.3275Z"
            stroke="#FFFFFF" stroke-width="1.5" stroke-miterlimit="10"/>
          <path
            d="M6.38379 26.1847C6.38379 21.9502 9.86328 18.5173 14.1552 18.5173H16.5315C20.8234 18.5173 24.3029 21.9502 24.3029 26.1847"
            stroke="#FFFFFF" stroke-width="1.5" stroke-miterlimit="10"/>
        </svg>

        <!-- <img src="/public/Icons/logout-hover.svg" alt="logout-hover">
        <img src="/public/Icons/logout.svg" alt="logout"> -->
      </span>
    </div>
  </div>
</nav>
